import { useEffect, useState } from 'react'

export function useDebounce<T>(value: T, delay = 750): T {
	const [debouncedValue, setDebouncedValue] = useState(value)

	useEffect(() => {
		const timer = window.setTimeout(() => setDebouncedValue(value), delay)

		return () => window.clearTimeout(timer)
	}, [value, delay])

	return debouncedValue
}
